import { DialogType } from "@/components/Dialogs/types";
import { PubSubEvents } from "@/types/PubSub";

/* eslint-disable @typescript-eslint/no-explicit-any */
type Callback = (payload?: any) => void;

class PubSub<Events extends string> {
  private listeners: Partial<Record<Events, Set<Callback>>> = {};

  subscribe(event: Events, callback: Callback): () => void {
    if (!this.listeners[event]) {
      this.listeners[event] = new Set();
    }
    this.listeners[event].add(callback);
    return () => this.unsubscribe(event, callback);
  }

  unsubscribe(event: Events, callback: Callback) {
    const set = this.listeners[event];
    if (set) {
      set.delete(callback);
      if (set.size === 0) {
        delete this.listeners[event];
      }
    }
  }

  publish(event: Events, payload?: any) {
    this.listeners[event]?.forEach((callback) => callback(payload));
  }

  clear(event?: Events) {
    if (event) {
      delete this.listeners[event];
    } else {
      this.listeners = {};
    }
  }
}

export const pubSub = new PubSub<PubSubEvents | DialogType>();
